export default {
  PROJECT_SET_LOADING: 'PROJECT_SET_LOADING',

  PROJECT_REQUEST: 'PROJECT_REQUEST',
  PROJECT_FAILURE: 'PROJECT_FAILURE',
  PROJECT_SUCCESS: 'PROJECT_SUCCESS',

  PROJECT_RESET: 'PROJECT_RESET',
};
